import { ArrowUp, ArrowDown, Minus } from 'lucide-react'
import type { ReactNode } from 'react'

interface StatCardProps {
  label: string
  value: string
  delta: number
  icon: ReactNode
  tone: 'brand' | 'green' | 'orange' | 'purple'
}

const TONE_STYLES: Record<StatCardProps['tone'], { bg: string; text: string }> = {
  brand:  { bg: 'bg-brand-50',    text: 'text-brand-600'    },
  green:  { bg: 'bg-green-50',    text: 'text-green-600'    },
  orange: { bg: 'bg-orange-50',   text: 'text-orange-600'   },
  purple: { bg: 'bg-purple-50',   text: 'text-purple-600'   },
}

export function StatCard({ label, value, delta, icon, tone }: StatCardProps) {
  const t = TONE_STYLES[tone]
  const positive = delta > 0
  const zero = delta === 0

  return (
    <div className="bg-surface border border-border rounded-xl shadow-card p-5">
      <div className="flex items-start justify-between">
        <div className="flex-1 min-w-0">
          <div className="text-sm text-muted">{label}</div>
          <div className="text-2xl font-bold text-text mt-1 truncate">{value}</div>
          <div className={[
            'mt-2 inline-flex items-center gap-1 text-xs font-medium px-2 py-0.5 rounded-full',
            zero ? 'bg-slate-100 text-slate-600'
              : positive ? 'bg-green-50 text-green-700' : 'bg-red-50 text-red-700',
          ].join(' ')}>
            {zero ? <Minus className="w-3 h-3" /> : positive ? <ArrowUp className="w-3 h-3" /> : <ArrowDown className="w-3 h-3" />}
            <span>{zero ? 'Không đổi' : `${positive ? '+' : ''}${delta.toFixed(1)}%`}</span>
            <span className="text-muted font-normal">so với tuần trước</span>
          </div>
        </div>
        <div className={`w-12 h-12 rounded-xl ${t.bg} ${t.text} flex items-center justify-center shrink-0`}>
          {icon}
        </div>
      </div>
    </div>
  )
}
